interface Contributors {
  name: string;
  role?: string;
}

// Record containing contributors each year. Follow pattern under if you are adding new contributors.
export const contributors: Record<string, Contributors[]> = {
  "2021/2022": [
    { name: "Kristoffer Grude" },
    { name: "Benedikte Bitnes" },
    { name: "Tord Espe" },
    { name: "Wilhelm Medhus" },
    { name: "Aina Lie" },
    { name: "Frederick Pretlove" },
    { name: "Håkon Sønstebø" },
    { name: "Liv Semlitsch" },
  ],
  "2022/2023": [
    { name: "Frederick Pretlove" },
    { name: "Aina Lie" },
    { name: "Håkon Sønstebø" },
    { name: "Liv Semlitsch" },
    { name: "Emilie Lysaker Høgne" },
    { name: "Herman Bergheim" },
    { name: "Karoline Torø" },
    { name: "Ola Hagerupsen Hansen" },
    { name: "Simen Birkeland" },
  ],
  "2023/2024": [
    { name: "Herman Bergheim" },
    { name: "Emilie Lysaker Høgne" },
    { name: "Karoline Torø" },
    { name: "Ola Hagerupsen Hansen" },
    { name: "Simen Birkeland" },
    { name: "Helene Hoel Jomaas" },
    { name: "Peter Mikalsen" },
    { name: "Sina X. Sprauten" },
    { name: "Kristian Sandernes" },
  ],
  "2024/2025": [
    { name: "Helene Hoel Jomaas" },
    { name: "Peter Mikalsen" },
    { name: "Sina X. Sprauten" },
    { name: "Kristian Sandernes" },
    { name: "Vegard R. Ragnhildstveit" },
    { name: "Tina Mikalsen" },
    { name: "Lars Haugsvær" },
    { name: "Hanne Haug" },
  ],
  "2025/2026": [
    { name: "Vegard R. Ragnhildstveit" },
    { name: "Tina Mikalsen" },
    { name: "Lars Haugsvær" },
    { name: "Hanne Haug" },
    { name: "Mille Maier" },
    { name: "Teodor Riddervold" },
    { name: "Ida Edvardsen" },
    { name: "Theodor Bischler" },
  ],
};
